import { memo } from 'react';

import type { ToastItem } from '../types';

import { Portal } from '../../Modal/subcomponents/Portal';
import { Toast } from '../Toast';
import { shouldShowDismissControl } from '../utils';

type ToastViewportProps = {
  onDismiss: (id: string) => void;
  toasts: ToastItem[];
};

export const ToastViewport = memo(
  ({ onDismiss, toasts }: ToastViewportProps) => {
    if (toasts.length === 0) {
      return null;
    }

    return (
      <Portal>
        <div
          aria-live="polite"
          aria-relevant="additions"
          className="eds-toast-viewport"
        >
          {toasts.map((toast) => {
            const showDismissControl = shouldShowDismissControl(toast);

            return (
              <div className="eds-toast-viewport--item" key={toast.id}>
                <Toast
                  link={toast.link}
                  onDismiss={
                    showDismissControl
                      ? () => {
                          toast.onDismiss?.();
                          onDismiss(toast.id);
                        }
                      : undefined
                  }
                  status={toast.status}
                  text={toast.text}
                  title={toast.title}
                />
              </div>
            );
          })}
        </div>
      </Portal>
    );
  },
);

ToastViewport.displayName = 'ToastViewport';
